import React, { useEffect } from "react";

const Home = () => {
  useEffect( () => {
    window.location = "https://www.beli-bitcoin.co";
  });
  return (
    <div className="d-flex justify-content-center flex-column align-items-center">
        Redirecting to Home
    </div>
  )
}
export default Home;
  